import { getLatestNotifigations, getUserOrganizations } from '@/api'
import { caption2, defaultText, leastText, notificationsBg, primary } from '@/constant'
import { ImageIcon } from '@/icon/ImageIcon'
import { NotificationDetail, Organizationinfo } from '@/types'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import {
  Box,
  Button,
  Divider,
  Fade,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import React, { useCallback, useContext, useMemo, useRef, useState } from 'react'
import Text from '@/components/Text'
import { useNavigate } from 'react-router-dom'
import CreateOrg from './createOrg'
import { InfoCardBase, NotificationEmptyIcon, OrgListItem, OrgMenu, OrgMenuItem } from './index'
import { NotificationContext } from '@/layout/NotificationIO'
import noti_app_highlight from '@/asset/img/favicon.jpg'
import dayjs from 'dayjs'

export interface InfoCardProps {
  info: Organizationinfo
  onChangeOrg: (orgInfo: Organizationinfo) => void
}

const getTime = (timeString: string) => {
  return dayjs(timeString).format('YYYY-MM-DD HH:mm')
}
const InfoCard: React.FC<InfoCardProps> = (props) => {
  const { info, onChangeOrg } = props
  const scrollOrgRef = useRef(null)
  const navigate = useNavigate()
  const { data, refetch } = useQuery(['getUserOrganizations'], () => getUserOrganizations(), {
    refetchOnMount: false,
  })

  const { notificatioinData } = useContext(NotificationContext)
  const { data: notifigationsdata, isLoading: notificationsLoading } = useQuery(
    ['getLatestNotifigations'],
    () =>
      getLatestNotifigations({
        page: 1,
        size: 10,
      }),
    {
      enabled: true,
      onSuccess: () => {
        setTimeout(() => {
          if (scrollOrgRef?.current) {
            // @ts-ignore
            scrollOrgRef?.current?.scrollIntoView({ behavior: 'smooth' })
          }
        })
      },
    },
  )
  const [create, setCreate] = useState<boolean>(false)
  const [menuOrg, setMenuOrg] = useState<Organizationinfo | null>(null)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const openMenu = useMemo(() => Boolean(anchorEl), [anchorEl])
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, value: Organizationinfo) => {
    event.stopPropagation()
    event.preventDefault()
    setAnchorEl(event.currentTarget)
    setMenuOrg(value)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
    setMenuOrg(null)
  }
  const afterCreate = useCallback(
    (orgData: Organizationinfo) => {
      onChangeOrg(orgData)
      setCreate(false)
      navigate(0)
      refetch()
    },
    [navigate, onChangeOrg, refetch],
  )

  const changeCreateModal = useCallback(
    (openModal: boolean) => () => {
      setCreate(openModal)
    },
    [],
  )

  const routeToNotification = useCallback(
    (message?: NotificationDetail) => () => {
      if (message)
        navigate(`/console/personal?tab=1&messageId=${message?.id}&type=${message?.logo_url ? 'app' : 'platform'}`)
      else navigate('/console/personal?tab=1')
    },
    [navigate],
  )
  // @ts-ignore
  const ifSelectedOrg = (org_id) => {
    return info?.id === org_id
  }
  return (
    <InfoCardBase
      sx={{
        height: '100%',
        '& nav:first-of-type': {
          flex: 1,
          display: 'flex',
          pb: '0',
          flexDirection: 'column',
          overflow: 'auto',
        },
      }}
    >
      <nav style={{ marginBottom: '4px', paddingLeft: '0', paddingRight: '0' }}>
        <List sx={{ width: '100%', overflowY: 'auto', pl: '14px', pr: '14px' }}>
          <ListItem
            disableGutters
            secondaryAction={
              <Button variant='text' sx={{ fontSize: '12px', paddingRight: 0 }} onClick={changeCreateModal(true)}>
                + 新空间
              </Button>
            }
          >
            <ListItemText
              primaryTypographyProps={{
                variant: 'button',
                sx: {
                  color: '#041B0F',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  fontFamily: 'AlibabaPuHuiTiBold, PingFang SC',
                },
              }}
              primary='空间'
            />
          </ListItem>
        </List>
        <List
          sx={{
            flex: 1,
            width: '100%',
            overflowY: 'auto',
            pt: 0,
          }}
        >
          {data?.data?.map((value) => (
            <OrgListItem
              sx={{ pl: '14px', pr: '14px' }}
              key={value.id}
              disableGutters
              ref={ifSelectedOrg(value?.id) ? scrollOrgRef : null}
            >
              <ListItemButton
                sx={{ pr: 0 }}
                onClick={() => {
                  if (!ifSelectedOrg(value?.id)) onChangeOrg(value)
                }}
                className={`${value.id === menuOrg?.id ? 'space_list_btn-active' : ''} 
            ${ifSelectedOrg(value?.id) ? 'space_list_btn-checked' : 'space_list_btn'}`}
                role={undefined}
                dense
              >
                <ListItemText primary={value.name} sx={{ color: 'rgba(0, 0, 0, 0.50)' }} />
                <IconButton
                  disableRipple
                  size='small'
                  className='icon_btn'
                  sx={{
                    visibility: value.id === menuOrg?.id ? 'visible!important' : '',
                  }}
                  onClick={(event) => handleMenuClick(event, value)}
                >
                  <MoreVertIcon
                    sx={{
                      transform: 'scale(0.9)',
                      '&:hover': { color: primary },
                      color: 'rgba(0, 0, 0, 0.50)',
                    }}
                  />
                </IconButton>
              </ListItemButton>
            </OrgListItem>
          ))}
          <OrgMenu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleCloseMenu}
            TransitionComponent={Fade}
            sx={{ borderRadius: '4px' }}
          >
            <OrgMenuItem
              onClick={() => {
                // @ts-ignore
                onChangeOrg(menuOrg)
                navigate('/console/space/base')
              }}
            >
              空间管理
            </OrgMenuItem>
            {/* <OrgMenuItem
              onClick={() => {
                // @ts-ignore
                onChangeOrg(menuOrg)
                navigate('/console/space/base')
              }}
            >
              成员管理
            </OrgMenuItem> */}
          </OrgMenu>
        </List>
      </nav>
      <CreateOrg open={create} onClose={changeCreateModal(false)} onOk={afterCreate} />
      <nav style={{ height: '370px' }}>
        <List sx={{ width: '100%', pt: 0 }}>
          <ListItem
            disableGutters
            secondaryAction={
              <Button variant='text' sx={{ fontSize: '12px', paddingRight: 0 }} onClick={routeToNotification()}>
                查看更多
              </Button>
            }
          >
            <ListItemText
              primaryTypographyProps={{
                variant: 'button',
                sx: {
                  fontWeight: '500',
                  fontSize: '14px',
                  color: '#041B0F',
                  fontFamily: 'AlibabaPuHuiTiBold!important',
                },
              }}
            >
              消息
              {notificatioinData?.total_number ? (
                <Box
                  component='span'
                  sx={{
                    height: '14px',
                    display: 'inline-block',
                    lineHeight: 1,
                    ml: '4px',
                    borderRadius: '20px',
                    padding: '0 8px',
                    background: notificationsBg,
                    color: '#fff',
                  }}
                >
                  {notificatioinData?.total_number > 100 ? (
                    '99+'
                  ) : (
                    <Box component='span' sx={{ transform: 'scale(0.8)', display: 'inline-block' }}>
                      {' '}
                      {notificatioinData?.total_number}
                    </Box>
                  )}
                </Box>
              ) : null}
            </ListItemText>
          </ListItem>
        </List>
        {notificationsLoading ? (
          [1, 2, 3, 4].map((value) => (
            <Box key={value} sx={{ mb: '30px' }}>
              <Skeleton width={252} height={26} />
              <Skeleton width={252} height={26} />
            </Box>
          ))
        ) : (
          <Stack
            direction='column'
            spacing={0}
            divider={<Divider sx={{ ml: '10px', mr: '10px', borderStyle: 'dashed' }} />}
          >
            {notifigationsdata?.detail ? (
              notifigationsdata?.detail?.slice(0, 4).map((value) => (
                <Paper key={value.id} className='info_item' elevation={0} sx={{ borderRadius: '4px' }}>
                  <Grid
                    sx={{ p: '10px', cursor: 'pointer' }}
                    onClick={routeToNotification(value)}
                    container
                    spacing={2}
                  >
                    <Grid item xs={12} sx={{ pl: '20px!important' }}>
                      <Box
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          lineHeight: '22px',
                        }}
                      >
                        <Box
                          className={'notice_red-dot'}
                          sx={{
                            mr: '12px',
                            width: '3px',
                            height: '3px',
                            borderRadius: '50%',
                            background: value.read_status === 1 ? notificationsBg : 'grey',
                            position: 'relative',
                            top: '-3px',
                            display: 'inline-block',
                          }}
                        />
                        <Typography
                          component='span'
                          variant='body2'
                          sx={{
                            color: value.read_status === 1 ? defaultText : leastText,
                          }}
                        >
                          {value.simple_text}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        pl: '16px!important',
                        pt: '10px!important',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <ImageIcon
                        src={value?.logo_url || noti_app_highlight}
                        sx={{
                          flexShrink: 0,
                          width: '12px',
                          height: '12px',
                          mr: '8px',
                        }}
                      />
                      <Typography
                        component='span'
                        variant='body2'
                        sx={{
                          color: caption2,
                          fontSize: '12px',
                          fontWeight: 300,
                        }}
                      >
                        {value.send_name || '百川云平台'}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        pl: '0px!important',
                        pt: '10px!important',
                        textAlign: 'right',
                      }}
                    >
                      <Typography
                        component='span'
                        variant='body2'
                        sx={{
                          color: caption2,
                          fontSize: '12px',
                          fontWeight: 300,
                        }}
                      >
                        {getTime(value.created_at)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              ))
            ) : (
              <>
                <Box
                  sx={{
                    margin: 'auto',
                    pr: '50px',
                    pt: '10px',
                    '& > div': { mb: '10px' },
                  }}
                >
                  <NotificationEmptyIcon />
                </Box>
                <Text size='xs' sx={{ color: leastText, textAlign: 'center' }}>
                  暂无消息
                </Text>
              </>
            )}
          </Stack>
        )}
      </nav>
    </InfoCardBase>
  )
}
export default InfoCard
